// Generated by Melange

import * as Buhta_models__Atd from "./Atd.js";
import * as Buhta_models__Protocol_Idp_v1_bs from "./generated/Protocol_Idp_v1_bs.js";

function decode(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_Idp_v1_bs.read_kratos_flow, param);
}

function decodeSession(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_Idp_v1_bs.read_login_session, param);
}

function decodeError(param) {
  return Buhta_models__Atd.decode(Buhta_models__Protocol_Idp_v1_bs.read_kratos_error, param);
}

const KratosFlow = {
  decode: decode,
  decodeSession: decodeSession,
  decodeError: decodeError
};

export {
  KratosFlow ,
}
/* Buhta_models__Atd Not a pure module */
